/**
 * @file Notification page: one event's details, with the actions it offers, such as ending the contract it names.
 * Failure path: each saga's `onError` resets `isSaving`, and the saga shows the message.
 */
import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import Time from "../../../Time/Time";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import NotificationUpdateWillMount from "../../../Middleware/Middlewares/NotificationUpdateWillMount";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { Timeline } from "../../Partials/Timeline/Timeline";
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { AbstractPane } from "../../Partials/AbstractPane/AbstractPane";


import CardContent from '@material-ui/core/CardContent';
import Card from '@material-ui/core/Card';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import * as moment from "moment";

class NotificationUpdate extends Component {
  protected middlewares: MiddlewareInterface[] = [
    NotificationUpdateWillMount
  ];

  public state = {
    endDate: null,
    endDateNotValid: false,
    expirationDate: null,
    openDeletedChargesPaymentsDialog: false,
    deletedCharges: [],
    isEndDialogOpen: false,
    isRenewDialogOpen: false,
    isExpirationDialogOpen: false,
    postProcessMessage: "",
    snoozeDate: Time.addDays(new Date(), 1),
    days: 1,
    isUnsnoozePopupOpen: false,
    isSnoozePopupOpen: false,
    note: "",
    update: false,
    isCheckFirstDateDialogOpen: false,
    checkFirstDate: null,
    event: null,
    events: [],
    fetchingEvents: true,
    charge: null,
    property: null,
    unit: null,
    contract: null,
    tenant: null,
    reacted: false
  }

  constructor(public props) {
    super(props);
  }

  public initializePage = (id: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_FOR_EVENT_DETAILS_PAGE,
      payload: {
        eventId: id
      },
      onSuccess: (event: EventInterface) => {
        if (typeof event === "undefined") {
          this.redirectBack();
          return;
        }

        this.setState({
          event: event,
          reacted: event.reacted
        });

        this.fetchEntityEvents(id);

        let contract = null;

        if (event.eventTypeId === 15 && !!event.charge && event.charge.removed === false) {
          const charge = event.charge;
          contract = charge.contract;
        } else {
          contract = event.contract;
        }

        const unit = !!contract && contract.unit ? contract.unit : event.unit;
        const tenant = contract?.tenant;
        const property = event.property;
        const charge = event.charge;

        this.setState({
          contract: contract,
          expirationDate: !!contract && contract.expirationDate ? contract.expirationDate : null,
          unit: unit,
          tenant: tenant,
          property: property,
          charge: charge
        });

        const postProcessMessage = this.props.app.postProcessMessage;

        if (postProcessMessage) {
          this.setState({
            postProcessMessage: postProcessMessage
          });

          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.state.postProcessMessage,
              type: "info"
            }
          });

          this.props.dispatch({
            type: Constants.POST_PROCESS_MESSAGE_CLEAR
          });
        }
      },
      onError: this.redirectBack
    });
  }

  public componentWillReceiveProps(nextProps) {
    const prevId = parseInt(this.props.params.id, 10);
    const id = parseInt(nextProps.params.id, 10);

    if (prevId !== id) {
      this.initializePage(id);
    }
  }

  public fetchEntityEvents = (entityId: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        refersToEventId: entityId,
        removed: 0,
      },
      onSuccess: data => {
        this.setState({events: [...data.events], fetchingEvents: false});
      }
    });
  }

  public openEndDialog = () => {
    this.setState({
      isEndDialogOpen: true
    });
  }

  public closeEndDialog = () => {
    this.setState({
      isEndDialogOpen: false,
      endDate: null
    });
  }

  public openRenewDialog = () => {
    this.setState({
      isRenewDialogOpen: true
    });
  }

  public closeRenewDialog = () => {
    this.setState({
      isRenewDialogOpen: false
    });
  }

  public openSetExpirationDateDialog = () => {
    this.setState({
      isExpirationDialogOpen: true
    });
  }

  public closeSetExpirationDateDialog = () => {
    this.setState({
      isExpirationDialogOpen: false
    });
  }

  public openUnsnoozeDialog = () => {
    this.setState({
      isUnsnoozePopupOpen: true
    });
  }

  public closeUnsnoozeDialog = () => {
    this.setState({
      isUnsnoozePopupOpen: false
    });
  }

  public openSnoozeDialog = () => {
    this.setState({
      isSnoozePopupOpen: true
    });
  }

  public closeSnoozeDialog = () => {
    this.setState({
      isSnoozePopupOpen: false
    });
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    const timeDiff = Math.abs(date.getTime() - new Date().getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    this.setState({
        [identifier]: date,
        days: diffDays,
        isCheckFirstDateDialogOpen: moment(date).date() === 1
      });
  }

  public changeDays = (event) => {
    const days = Number.parseInt(event.target.value);
    const snoozeDate = Time.addDays(new Date(), days);

    this.setState({
      days: days,
      snoozeDate: snoozeDate
    });
  }

  public saveEndDate = (contract: ContractInterface) => {
    let date = this.state.endDate

    this.setState({
      endDateNotValid: false
    }, () => {
      if (!(date instanceof Date && !isNaN(Number(date)))) {
        return this.setState({endDateNotValid: true})
      }

      this.saving(() => {
        return this.props.dispatch({
          type: Constants.GLOBAL_CONTRACT_END_START,
          payload: {
            contractId: !!contract && contract.id,
            endDate: date
          },
          onSuccess: res => {
            this.setState({
              isSaving: false,
              deletedCharges: res.data.removedCharges,
              openDeletedChargesPaymentsDialog: true,
              endDate: date
            });

            // this.props.dispatch({
            //   type: Constants.POST_PROCESS_MESSAGE,
            //   payload: {
            //     postProcessMessage: this.trans("snackbar-expiring-contract-notification-deactivated-contract-ended")
            //   }
            // });

            this.redirect("/app/dashboard/contracts");
          },
          onError: () => {
            this.setState({
              isSaving: false
            });
          }
        });
      });

      this.closeEndDialog();
    });
  }

  public clearEndDate = (contract: ContractInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_CONTRACT_END_START,
        payload: {
          contractId: !!contract && contract.id,
          endDate: null
        },
        onSuccess: () => {
          this.setState({
            isSaving: false,
            // deletedCharges: res.data.removedCharges,
            // openDeletedChargesPaymentsDialog: true,
            endDate: null
          });

          // this.props.dispatch({
          //   type: Constants.POST_PROCESS_MESSAGE,
          //   payload: {
          //     postProcessMessage: this.trans("snackbar-expiring-contract-notification-deactivated-contract-ended")
          //   }
          // });

          // this.props.dispatch({
          //   type: Constants.SNACKBAR_ADD_MESSAGE,
          //   payload: {
          //     message: this.trans("snackbar-expiring-contract-notification-deactivated-contract-ended"),
          //     type: "info"
          //   }
          // });

          this.redirect("/app/dashboard/contracts");
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public saveExpirationDate = (contract: ContractInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_CONTRACT_EXPIRATION_START,
        payload: {
          contractId: !!contract && contract.id,
          expirationDate: this.state.expirationDate
        },
        onSuccess: () => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });

          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("snackbar-expiring-contract-notification-deactivated-contract-continued"),
              type: "info"
            }
          });

          this.redirect("/app/dashboard/contracts");
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public getDeletedCharges = charges => {
    if(!!charges) {
      return charges.map((charge: ChargeInterface, index: number) => {
        return (
          <TableRow hover key={index}>
            <TableCell style={{width: "24px", paddingLeft: "10px", paddingRight: "5px"}}>
              <div className="icon icon-ic-assignment"></div>
            </TableCell>
            <TableCell style={{width: "40%"}}>{charge.description ? charge.description : ""}</TableCell>
            <TableCell style={{width: "20%"}}>
              {this.formatter.formatDate(new Date(charge.firstDate))}
            </TableCell>
            <TableCell style={{ width: "40%", textAlign: "right"}}>
              {this.formatter.formatNumber(charge.amount, charge.currency)}
            </TableCell>
          </TableRow>
        );
      });
    }
  }

  public createPayment = () => {
    this.props.dispatch({
      type: Constants.REDIRECT_PATH,
      payload: {
        redirectPath: "/app/dashboard/charges"
      }
    });

    return this.redirect(`/app/charge/update/${this.state.charge?.id}`);
  }

  public snoozeNotification = () => {
    if (this.state.days < 1) {
      return;
    }

    if (this.state.note) {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_CREATE_START,
        payload: {
          content: {
            note: this.state.note
          },
          refersToEventId: this.state.event && this.state.event.id,
          eventTypeId: 17
        }
      });
    }

    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_SNOOZE_START,
      payload: {
        event: this.state.event,
        snoozeDate: this.state.snoozeDate
      },
      onSuccess: () => {
        this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: `${this.trans("snackbar-notification-snoozed")} ${this.formatter.formatDate(this.state.snoozeDate)}`,
            type: "info"
          }
        });

        this.redirectBack();
      }
    });
  }

  public unsnoozeNotification = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_SNOOZE_START,
      payload: {
        event: this.state.event,
        snoozeDate: null
      },
      onSuccess: () => {
        this.redirect("/app/dashboard/contracts");
      }
    });
  }

  public renderSnoozeButton = () => {
    const isRemoved = this.state.event && this.state.event.removed !== undefined ? this.state.event.removed : false;

    return (
      <Button
        color="primary"
        onClick={this.openSnoozeDialog}
        style={{marginRight: "10px"}}
        disabled={isRemoved}
      >
        {this.trans("snooze")}
      </Button>
    );
  }

  public renderAbstractPane = () => {
    const unit: UnitInterface = this.state.unit;
    const contract: ContractInterface = this.state.contract;
    const tenant: PersonInterface | CompanyInterface = this.state.tenant;
    const charge: ChargeInterface = this.state.charge;
    const property: PropertyInterface = this.state.property;

    return (
      <AbstractPane
				title={this.trans("section/charge-info/relatedtoobject")}
        entities={[contract, unit, property, charge, tenant]}
			/>
    );
  }

  public delete = (): void => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_DELETE_START,
      payload: {
        editing: false,
        event: this.state.event
      },
      onSuccess: () => {
        this.redirectBack();
      }
    });
  }

  public changeStatus = (): void => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_UPDATE_START,
        payload: {
          ...this.state.event.data,
          reacted: !this.state.reacted,
          content: this.state.event && this.state.event.content ? this.state.event.content : {}
        },
        onSuccess: (event) => {
          this.initializePage(event.id)
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public render() {
    let minExpirationDate = null;
    const isRemoved = this.state.event && this.state.event.removed !== undefined ? this.state.event.removed : false;

    if (this.state.contract) {
      minExpirationDate = this.state.contract.firstDate < new Date() ? new Date() : this.state.contract.firstDate;
    }

    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header align-center has-back-button">
            <div className="back-arrow-wrapper" onClick={this.redirectBack}>
              <div className="icon icon-ic-arrow-back icon-color"></div>
            </div>
            <h1>{this.trans("notification-details")}</h1>
          </div>
          <div className="box component-event-update">
            {!!this.state.event && this.state.event.snoozeDate && (
              <div className="component-wrapper">
                <Card>
                  {isRemoved && (<p style={{color: "#00BCD4"}}>{this.trans("event-is-removed")}</p>)}
                  <CardContent className="snoozed-info" style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 20px 0px 20px"
                  }}>
                    <div style={{display: "flex", alignItems: "center"}}>
                      <div className="icon-wrapper">
                        <div className="icon icon-ic-info"></div>
                      </div>
                      <h2 style={{marginLeft: "15px", fontWeight: "normal"}}>
                        {this.trans("snackbar-notification-snoozed")} {this.formatter.unitListingFormatDate(!!this.state.event && this.state.event.snoozeDate)}
                      </h2>
                    </div>
                    <Button
                      color="primary"
                      onClick={this.openUnsnoozeDialog}
                      style={{marginRight: "10px"}}
                      disabled={isRemoved}
                    >
                      {this.trans("unsnooze")}
                    </Button>
                  </CardContent>
                </Card>
              </div>
            )}

            {this.state.event && this.state.event.eventTypeId === 15 && (
              <div className="component-wrapper no-margin-top">
                <div className="component">
                  <Card className="card">
                    <div className="label-container no-borders has-icon">
                      <h3 className="card-title" style={{display: "inline-flex", position: "relative"}}>
                        <div className="icon icon-ic-notification" style={{position: "absolute", left: "-40px"}}></div>
                        {this.trans("unpaid-charge")}
                      </h3>
                      <div className="button-container">
                        {!!this.state.event && !this.state.event.removed && !this.state.event.reacted && !this.state.event.snoozeDate && this.renderSnoozeButton()}
                        {this.state.charge && this.state.charge.amount !== this.state.charge.amountPaid && (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              if (this.checkProcessIsBusy({
                                                action: "link",
                                                entityName: "charge",
                                                entity: this.state.charge
                                              })) {
                                this.openIsBusyPopup();
                              } else {
                                this.createPayment();
                              }
                            }}
                            disabled={isRemoved}
                          >
                            {this.trans("button-pay")}
                          </Button>
                        )}
                      </div>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", justifyContent: "space-between", padding: "20px 20px 20px 65px"}}>
                      <p style={{color: "#404040", fontSize: "14px", margin: "0 0 10px 0"}}>
                        {this.trans("unpaid-notification-was-created-because")}
                      </p>

                      <TextField
                        autoComplete="off"
                        className="form-element no-border"
                        type="text"
                        label={this.trans("created")}
                        value={this.formatter.formatDate(this.state.event && this.state.event.createdAt) || this.trans("role-none")}
                        disabled={true}
                        style={{width: "30%"}}
                        variant="standard"
                        error={false}
                      />
                    </div>
                    {this.renderAbstractPane()}
                  </Card>
                </div>
              </div>
            )}

            {this.state.event && this.state.event.eventTypeId === 16 && (
              <div className="component-wrapper no-margin-top">
                <div className="component">
                  <Card className="card">
                    <div className="label-container no-borders has-icon">
                      <h3 className="card-title" style={{display: "inline-flex", position: "relative"}}>
                        <div className="icon icon-ic-notification" style={{position: "absolute", left: "-40px"}}></div>
                        {this.trans("expiring-contract")}
                      </h3>
                      <div className="button-container">
                        {!!this.state.event && !this.state.event.removed && !this.state.event.snoozeDate && this.renderSnoozeButton()}
                        <Button
                          color="primary"
                          onClick={() => {
                            if (this.checkProcessIsBusy({
                                                      action: "end",
                                                      entityName: "contract",
                                                      entity: this.state.contract
                                                    })) {
                              this.openIsBusyPopup();
                            } else {
                              this.openEndDialog()
                            }
                          }}
                          style={{marginRight: "10px"}}
                          disabled={isRemoved}
                        >
                          {this.trans("set-end-date")}
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            if (this.checkProcessIsBusy({
                                                      action: "renew",
                                                      entityName: "contract",
                                                      entity: this.state.contract
                                                    })) {
                              this.openIsBusyPopup();
                            } else {
                              this.openRenewDialog()
                            }
                          }}
                          disabled={isRemoved}
                        >
                          {this.trans("button-renew")}
                        </Button>
                      </div>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", justifyContent: "space-between", padding: "20px 20px 20px 65px"}}>
                      <p style={{color: "#404040", fontSize: "14px", margin: "0 0 10px 0"}}>
                        {this.trans("expiring-notification-was-created-because")}
                      </p>

                      <TextField
                        autoComplete="off"
                        className="form-element no-border"
                        type="text"
                        label={this.trans("created")}
                        value={this.formatter.formatDate(this.state.event && this.state.event.createdAt) || this.trans("role-none")}
                        disabled={true}
                        style={{width: "30%"}}
                        variant="standard"
                        error={false}
                      />
                    </div>
                    {this.renderAbstractPane()}
                  </Card>
                </div>
              </div>
            )}

            {this.state.event && this.state.event.eventTypeId === 33 && (
              <div className="component-wrapper no-margin-top">
                <div className="component">
                  <Card className="card">
                    <div className="label-container no-borders has-icon">
                      <h3 className="card-title" style={{display: "inline-flex", position: "relative"}}>
                        <div className="icon icon-ic-notification" style={{position: "absolute", left: "-40px"}}></div>
                        {this.trans("event-update-contract-prices")}
                      </h3>
                      <div className="button-container">
                        {!!this.state.event && !this.state.event.removed && !this.state.event.reacted && !this.state.event.snoozeDate && this.renderSnoozeButton()}
                      </div>
                    </div>
                    <div className="row" style={{position: "relative"}}>
                      <div className="grid"></div>
                      <div className="grid">
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "space-between", padding: "20px 0"}}>
                          <p style={{color: "#404040", fontSize: "14px", margin: "0 0 10px 0"}}>
                            {this.trans("event-update-contract-prices-was-created-because-part-1")}
                          </p>

                          <p style={{color: "#404040", fontSize: "14px", margin: "0 0 10px 0"}}>
                            {this.trans("event-update-contract-prices-was-created-because-part-2")}
                          </p>

                          <TextField
                            autoComplete="off"
                            className="form-element no-border"
                            type="text"
                            label={this.trans("created")}
                            value={this.formatter.formatDate(this.state.event && this.state.event.createdAt) || this.trans("role-none")}
                            disabled={true}
                            style={{width: "30%"}}
                            variant="standard"
                            error={false}
                          />
                        </div>
                        <div style={{position: "absolute", right: "20px", top: "0"}}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={!this.state.reacted}
                                onChange={this.changeStatus}
                                color="primary"
                              />
                              }
                            label={this.trans("status-open")}
                          />
                        </div>
                      </div>
                    </div>
                    {this.renderAbstractPane()}
                  </Card>
                </div>
              </div>
            )}
          </div>
          { this.isBeta() && 
            <Timeline
              {...this.props}
              relations={{ refersToEventId: this.state.event && this.state.event.id }}
              entityEvents={this.state.events}
              fetchEntityEvents={this.fetchEntityEvents.bind(this, this.state.event && this.state.event.id)}
              fetchingEvents={this.state.fetchingEvents}
            />
          }
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("end-contract-modal-title")}
          content={(
            <div>
              <p>{this.trans("dialog/preprocess-endcontract-info1")}</p>
              <div style={{width: "50%"}}>
                <DatePickerComponent
                  {...this.props}
                  label={this.state.contract && this.state.contract.endDate ?
                    this.trans("end-date") : this.trans("label-click-set-the-end-date")}
                  initialDate={this.state.contract ? this.state.contract.endDate : null}
                  onChange={date => this.selectDate(date, "endDate")}
                  minDate={this.state.contract && this.state.contract.firstDate}
                  minDatePlusDays={1}
                  minDateMessage={this.trans("field/lastfinalenddate-info/error")}
                  clearButton={true}
                  error={this.state.endDateNotValid && this.trans("be_ajv_not_validated")}
                />
              </div>
              <p>{this.trans("dialog/preprocess-endcontract-info2")}</p>
              <p>{!!this.state.contract && !!this.state.contract.isActive && this.trans("dialog/preprocess-endcontract-info3")}</p>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("end-contract")}
          positiveButtonStyle={{backgroundColor:"red"}}
          openLeavePrompt={this.state.isEndDialogOpen}
          prioritizeClosing={true}
          onDiscard={this.closeEndDialog}
          onSave={() => this.saveEndDate(this.state.contract)}
          hideCross={true}
          additionalBtns={this.state.contract && !!this.state.contract.isActive && (
            [<Button
              key="dialog-additional-btn"
              color="primary"
              onClick={this.openRenewDialog}
              disabled={isRemoved}
            >
              {this.trans("renew-contract")}
            </Button>]
          )}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("renew-contract")}
          content={(
            <div>
              <p>{this.trans("dialog/renewcontract-info1")}</p>
              <p>{this.trans("dialog/renewcontract-info2")}</p>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("renew-contract")}
          openLeavePrompt={this.state.isRenewDialogOpen}
          prioritizeClosing={true}
          onDiscard={this.closeRenewDialog}
          onSave={() => {
            this.closeRenewDialog();
            this.props.dispatch({
              type: Constants.REDIRECT_PATH,
              payload: {
                redirectPath: "/app/dashboard/contracts"
              }
            });
            this.redirect(`/app/contract/extend/${this.state.contract && this.state.contract.id}/0`);
          }}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("continue-contract")}
          content={(
            <div>
              <p>{this.trans("you-are-about-to-continue-contract")}</p>
              <div style={{width: "30%"}}>
                <DatePickerComponent
                  {...this.props}
                  className="scroll-to-expirationDate"
                  label={this.state.contract && this.state.contract.expirationDate ?
                    this.trans("expiration-date") : this.trans("label-expiration-date-not-set")}
                  initialDate={this.state.expirationDate}
                  onChange={date => this.selectDate(date, "expirationDate")}
                  minDate={minExpirationDate}
                  minDatePlusDays={0}
                  clearButton={true}
                  error={this.getErrorFor("expirationDate")}
                />
              </div>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("label-continue")}
          openLeavePrompt={this.state.isExpirationDialogOpen}
          prioritizeClosing={true}
          onDiscard={this.closeSetExpirationDateDialog}
          onSave={() => { this.closeSetExpirationDateDialog(); this.saveExpirationDate(this.state.contract); }}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("contract-ended")}
          content={(
            <div>
              {
                <div>
                  {
                    this.state.endDate > new Date() && (
                      <div>
                        <p>{this.trans("dialog/postprocess-endcontract-ending-info-1",
                          {endDate: this.formatter.formatDate(this.state.endDate)})}
                        </p>
                        <p>{this.trans("dialog/postprocess-endcontract-ending-info-2")}
                        </p>
                      </div>
                    )
                  }
                  {
                    this.state.endDate <= new Date() && (
                      <div>
                        <p>{this.trans("dialog/postprocess-endcontract-ended-info-1",
                          {endDate: this.formatter.formatDate(this.state.endDate)})}
                        </p>
                    </div>
                    )
                  }
                </div>
              }
            </div>
          )}
          positiveButtonLabel={this.trans("button-close")}
          onlyPositiveButton={true}
          openLeavePrompt={this.state.openDeletedChargesPaymentsDialog}
          prioritizeClosing={true}
          onSave={() => {
            this.setState({ openDeletedChargesPaymentsDialog: false });
          }}
        />

        <PromptDialog 
          {...this.props}
          title={this.trans("snooze")}
          content={(
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline",
                  marginBottom: "-10px"
                }}
              >
                <TextField
                  autoComplete="off"
                  className="form-element"
                  label={this.trans("snooze-for-days")}
                  value={this.state.days}
                  onChange={this.changeDays}
                  style={{width: "45%"}}
                  type="number"
                  variant="standard"
                  error={this.state.days < 1 && !!this.trans("you-can-snooze-for-1-day")}
                />
                {this.state.days < 1 && <div className="component-error-text">{this.getErrorFor("you-can-snooze-for-1-day")}</div>}

                <p style={{margin: "0", fontSize: "12px", color: "#b2b2b2"}}>{this.trans("or")}</p>
                <div style={{width: "45%"}}>
                  <DatePickerComponent
                    {...this.props}
                    className="scroll-to-snoozeDate"
                    label={this.trans("snooze-until-date")}
                    initialDate={this.state.snoozeDate}
                    onChange={date => this.selectDate(date, "snoozeDate")}
                    minDate={new Date()}
                    minDatePlusDays={1}
                    clearButton={true}
                    error={this.state.days < 1 && !!" "}
                  />
                </div>
              </div>

              <div style={{marginBottom: "-10px"}}>
                <TextField
                  autoComplete="off"
                  className="form-element full-size scroll-to-note"
                  type="text"
                  multiline={true}
                  rowsMax={10}
                  label={this.trans("note")}
                  value={this.state.note}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
                  variant="standard"
                  error={!!this.getErrorFor("note")}
                />
                {!!this.getErrorFor("note") && <div className="component-error-text">{this.getErrorFor("note")}</div>}
              </div>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("snooze")}
          openLeavePrompt={this.state.isSnoozePopupOpen}
          prioritizeClosing={true}
          onDiscard={() => {this.closeSnoozeDialog(); this.setState({
            snoozeDate: Time.addDays(new Date(), 1),
            days: 1,
            note: ""
          });}}
          onSave={() => {this.closeSnoozeDialog(); this.snoozeNotification();}}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("unsnooze")}
          content={(<p>{this.trans("snooze-date-will-be-removed")}</p>)}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("unsnooze")}
          openLeavePrompt={this.state.isUnsnoozePopupOpen}
          prioritizeClosing={true}
          onDiscard={this.closeUnsnoozeDialog}
          onSave={() => {this.closeUnsnoozeDialog(); this.unsnoozeNotification();}}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("title-date")}
          content={(
            <div>
              <p>{this.trans("dialog/preprocess-info/checkfirstdate")}</p>
              <p>{this.trans("dialog/preprocess-info2/checkfirstdate")}</p>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-continue")}
          openLeavePrompt={this.state.isCheckFirstDateDialogOpen}
          prioritizeClosing={true}
          onDiscard={() => this.setState({isCheckFirstDateDialogOpen: false})}
          onSave={() => { this.setState({isCheckFirstDateDialogOpen: false}); this.selectDate(this.state.checkFirstDate, "checkFirstDate") }}
          hideCross={true}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    charges: state.charges,
    events: state.events,
    component: state.notificationUpdate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  NotificationUpdate
);
